import React from 'react'

interface ContainerOverFrequencyVisualizerProps {
  children: React.ReactNode
}

export function ContainerOverFrequencyVisualizer({ children }: ContainerOverFrequencyVisualizerProps) {
  return <div className="absolute inset-0 flex items-center justify-center text-primary-inverse">{children}</div>
}
